<epay-page-content [pagetitle]="pagetitle">
  <div class="box-panel shadow max-w max-gs" style="max-width: 35rem !important;">
    <div class="m--pa4">
      <h2 class="mb-5 text-center">Contact Us</h2>


      <div class="row text-center">
        <div class="col">
          <h3><i class="fa fa-map-marker" aria-hidden="true"></i> Address</h3>
          MO Family Support Payment Center (MO FSPC) <br>
          P. O. Box 109006 <br>
          Jefferson City, MO 65110-9006 <br>
        </div>

        <div class="col">
          <div class="row ">
            <div class="">
              <div class="row container">
                <h3 style="padding-left: 0; padding-right: 0;"><i class="fa fa-phone" aria-hidden="true"></i>
                Telephone</h3>
                <div class="text-center">1-888-761-3665</div> 
              </div>

              <br>

              <div class="row container">
                <h3 style="padding-left: 0; padding-right: 0;"><i class="fa fa-fax" aria-hidden="true"></i>
                Fax</h3>
                <div class="text-center">1-573-761-1628</div>
              </div>

            </div>

          </div>
        </div>

      </div>
      <br>

      <div class="">
          <div class="text-center">
            <div *ngIf="this.chatLive">
              <h3>Live Chat</h3>
              <span>
                <img (click)="openChat()" src="../../../../../assets/images/chaticonmid.png" 
                class="live-chat-btn" alt="Customer Service Live Chat Icon" 
                style="cursor: pointer;">
              </span>
            </div>
          </div>
      </div>



      
    </div>
  </div>
</epay-page-content>
